import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=6d07674a&scoped=true&"
import script from "./Btn.vue?vue&type=script&lang=js&"
export * from "./Btn.vue?vue&type=script&lang=js&"
import style0 from "./Btn.vue?vue&type=style&index=0&id=6d07674a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07674a",
  null
  
)

export default component.exports